import React from 'react';
import { Col, DropdownMenu, Row } from '@paypalcorp/pp-react';
import styles from './LanguageCountrySelector.module.less';
import { trackFieldChange, trackFieldClosed, trackFieldFocus } from '../../lib/fpti';
import { DOMAIN_TYPES } from '../../Page/Customize/Constants/values';
import CountryDropdown from '../../Page/BNPL/CountrySelector/CountryDropdown';
import classNames from 'classnames';
import { isUserLoggedInSelector } from '../../store/App/selectors';
import { useSelector } from 'react-redux';

const LanguageCountrySelector = ({
  languageOptions,
  countryOptions,
  selectedLanguage,
  handleSelectLanguage
}) => {
  const isUserLoggedIn = useSelector(isUserLoggedInSelector);
  if (!languageOptions && !countryOptions) {
    return null;
  }

  if (
    !languageOptions[DOMAIN_TYPES.BACKEND] &&
    !languageOptions[DOMAIN_TYPES.FRONTEND] &&
    !countryOptions
  ) {
    return null;
  }
  const language_sticky_bar = classNames(styles.language_sticky_bar, {
    [styles.language_sticky_bar_loggedIn]: isUserLoggedIn
  });

  return (
    <Row id="language-selector" className={language_sticky_bar} noGutters>
      {languageOptions[DOMAIN_TYPES.FRONTEND] && (
        <Col xs="auto" className={styles.language_field}>
          <DropdownMenu
            className={styles.language_dropdown}
            label="Frontend"
            options={languageOptions[DOMAIN_TYPES.FRONTEND]}
            onClick={() => trackFieldFocus('Frontend')}
            onChange={(e) => {
              handleSelectLanguage(DOMAIN_TYPES.FRONTEND, e.target.value);
              trackFieldChange('Frontend', e.target.value);
            }}
            onClose={() => trackFieldClosed('Frontend')}
            value={selectedLanguage[DOMAIN_TYPES.FRONTEND]}
          />
        </Col>
      )}
      {languageOptions[DOMAIN_TYPES.BACKEND] && (
        <Col xs="auto" className={styles.language_field}>
          <DropdownMenu
            className={styles.language_dropdown}
            label="Backend"
            options={languageOptions[DOMAIN_TYPES.BACKEND]}
            onClick={() => trackFieldFocus('Backend')}
            onChange={(e) => {
              handleSelectLanguage(DOMAIN_TYPES.BACKEND, e.target.value);
              trackFieldChange('Backend', e.target.value);
            }}
            onClose={() => trackFieldClosed('Backend')}
            value={selectedLanguage[DOMAIN_TYPES.BACKEND]}
          />
        </Col>
      )}

      {countryOptions && (
        <Col xs="auto" className={styles.country_field}>
          <CountryDropdown countryList={countryOptions} />
        </Col>
      )}
    </Row>
  );
};

export default LanguageCountrySelector;
